var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.info))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }